import { syntaxTree } from '@codemirror/language';

export const findBracketPosition = (doc, from, to) => {
    for (let i = from; i < Math.min(from + 20, to); i++) {
        const char = doc.sliceString(i, i + 1);
        if (char === '{' || char === '[') {
            return i;
        }
    }
    return from;
};

export const calculateFoldRange = (startLine, endLine) => {
    let foldFrom = startLine.to;
    let foldTo = endLine.from;

    const startLineText = startLine.text;
    let lastNonWhitespace = startLineText.length;
    for (let i = startLineText.length - 1; i >= 0; i--) {
        if (startLineText[i] !== ' ' && startLineText[i] !== '\t') {
            lastNonWhitespace = i + 1;
            break;
        }
    }
    foldFrom = startLine.from + lastNonWhitespace;

    const endLineText = endLine.text;
    let firstNonWhitespace = 0;
    for (let i = 0; i < endLineText.length; i++) {
        if (endLineText[i] !== ' ' && endLineText[i] !== '\t') {
            firstNonWhitespace = i;
            break;
        }
    }
    foldTo = endLine.from + firstNonWhitespace;

    return foldFrom < foldTo ? { from: foldFrom, to: foldTo } : null;
};

export const collectFoldableNodes = (tree) => {
    const nodes = [];
    tree.iterate({
        enter: (node) => {
            if (!node.type) return;
            const nodeType = node.type.name;
            if (nodeType === 'Object' || nodeType === 'Array') {
                const from = node.from;
                const to = node.to;
                if (from >= to || (to - from) <= 2) return;
                nodes.push({ from, to, size: to - from });
            }
        }
    });
    return nodes;
};

export const getArrayFoldLabel = (length, uiLanguage) => (
    uiLanguage === 'zh' ? `${length}项` : `${length} items`
);

export const getArrayFallbackLabel = (uiLanguage) => (
    uiLanguage === 'zh' ? '数组' : 'array'
);

export const getFoldPlaceholderData = (state, range, uiLanguage) => {
    let node = syntaxTree(state).resolveInner(range.from, 1);

    while (node) {
        const containsRange = node.from <= range.from && node.to >= range.to;
        if (!containsRange) {
            node = node.parent;
            continue;
        }

        if (node.name === 'Array') {
            try {
                const value = JSON.parse(state.sliceDoc(node.from, node.to));
                return Array.isArray(value)
                    ? { kind: 'array', label: getArrayFoldLabel(value.length, uiLanguage) }
                    : { kind: 'default', label: '...' };
            } catch (error) {
                return { kind: 'array', label: getArrayFallbackLabel(uiLanguage) };
            }
        }

        if (node.name === 'Object') {
            return { kind: 'object', label: '...' };
        }

        node = node.parent;
    }

    return { kind: 'default', label: '...' };
};

export const createFoldPlaceholderDataGetter = (uiLanguage) => (state, range) =>
    getFoldPlaceholderData(state, range, uiLanguage);

export const createFoldPlaceholder = (view, onclick, prepared) => {
    const element = document.createElement('button');
    element.type = 'button';
    element.className = `cm-foldPlaceholder fd-fold-placeholder fd-fold-placeholder-${prepared?.kind || 'default'}`;
    element.textContent = prepared?.label || '...';
    element.setAttribute('aria-label', view.state.phrase('folded code'));
    element.title = view.state.phrase('unfold');
    element.onclick = onclick;
    return element;
};
